import { Poly } from "../../Poly";
export class ViewersRegister {
  constructor(scene) {
    this.scene = scene;
    this._viewersById = /* @__PURE__ */ new Map();
  }
  registerViewer(viewer) {
    this._viewersById.set(viewer.id(), viewer);
    this._updateCache();
  }
  unregisterViewer(viewer) {
    this._viewersById.delete(viewer.id());
    this._updateCache();
  }
  traverseViewers(callback) {
    this._viewersById.forEach(callback);
  }
  viewer(options) {
    const createViewerOptions = {
      camera: options.camera,
      canvas: options.canvas,
      scene: this.scene
    };
    const newViewer = Poly.camerasRegister.createViewer(createViewerOptions);
    return newViewer;
  }
  firstViewer() {
    return this._firstViewer;
  }
  _updateCache() {
    this._firstViewer = void 0;
    this._viewersById.forEach((viewer) => {
      this._firstViewer = this._firstViewer || viewer;
    });
  }
}
